export const ACCORDION_CONTENT_STYLE = {
  margin: '1.25rem 0',
}
